import GiveMeFive from "../../assets/images/givemefive.png";
import ListType from "../../assets/images/list-type.png";
import OrangeStar from "../../assets/images/orange-star.png";

const WhoCanApply = () => {
  return (
    <section
      id="kimler-katilabilir"
      className="w-full flex justify-center pt-10 sm:pt-14 md:pt-14 lg:pt-20 xl:pt-24 bg-[url('../../assets/images/who-can-apply-bg.png')] bg-center bg-cover bg-no-repeat relative"
    >
      <img
        className="animate-spin-slow w-[40px] sm:w-[60px] lg:w-[100px] xl:w-[129px] absolute right-5 lg:right-8 xl:right-10 top-10 lg:top-14 xl:top-20"
        src={OrangeStar}
        alt="orange star"
      />
      <div className="w-4/5 flex flex-col items-center space-y-10 lg:space-y-20">
        <div className="text-center">
          <h4 className="leading-none">
            <span
              style={{ fontFamily: "Gotham" }}
              className="font-bold text-[25px] lg:text-[82px] text-[#28495B]"
            >
              KİMLER
            </span>
            <br />
            <span
              style={{ fontFamily: "Gotham" }}
              className="font-bold text-[25px] lg:text-[82px] text-[#EF7C61]"
            >
              KATILABİLİR?
            </span>
          </h4>
        </div>
        <div className="w-full lg:w-4/5 relative flex flex-row justify-end pr-3">
          <img
            loading="lazy"
            className="z-10"
            src={GiveMeFive}
            alt="givemefive"
          />
          <ul className="w-4/5 lg:w-4/5 absolute py-4 lg:py-0 pl-10 md:px-10 top-2 sm:top-8 md:top-14 lg:top-14 xl:top-24 space-y-2 lg:space-y-5 lg:pl-6 z-20 mr-10">
            <li
              style={{ fontFamily: "Poppins" }}
              className="flex flex-row text-[8px] sm:text-[14px] md:text-[16px] lg:text-[18px] xl:text-[21px] items-start font-semibold text-white"
            >
              <img
                loading="lazy"
                className="mt-1 mr-2 w-[10px] lg:w-[22px] h-[10px] lg:h-[22px] min-w-[10px] lg:min-w-[22px] min-h-[10px] lg:min-h-[22px] "
                src={ListType}
                alt="list item"
              />
              <span>
                Gelişimine katkı sağlayacak programları keşfetmeye hevesli,
              </span>
            </li>
            <li
              style={{ fontFamily: "Poppins" }}
              className="flex flex-row text-[8px] sm:text-[14px] md:text-[16px] lg:text-[18px] xl:text-[21px] items-start font-semibold text-white"
            >
              <img
                loading="lazy"
                className="mt-1 mr-2 w-[10px] lg:w-[22px] h-[10px] lg:h-[22px] min-w-[10px] lg:min-w-[22px] min-h-[10px] lg:min-h-[22px] "
                src={ListType}
                alt="list item"
              />
              <span>
                Vizyonunu, ﬁkirlerini ve motivasyonunu yarınlara dönüştürmek
                isteyen,
              </span>
            </li>
            <li
              style={{ fontFamily: "Poppins" }}
              className="flex flex-row text-[8px] sm:text-[14px] md:text-[16px] lg:text-[18px] xl:text-[21px] items-start font-semibold text-white"
            >
              <img
                loading="lazy"
                className="mt-1 mr-2 w-[10px] lg:w-[22px] h-[10px] lg:h-[22px] min-w-[10px] lg:min-w-[22px] min-h-[10px] lg:min-h-[22px] "
                src={ListType}
                alt="list item"
              />
              <span>
                Şirket kültür ve değerlerini yakından öğrenmeyi amaçlayan,
              </span>
            </li>
            <li
              style={{ fontFamily: "Poppins" }}
              className="flex flex-row text-[8px] sm:text-[14px] md:text-[16px] lg:text-[18px] xl:text-[21px] items-start font-semibold text-white"
            >
              <img
                loading="lazy"
                className="mt-1 mr-2 w-[10px] lg:w-[22px] h-[10px] lg:h-[22px] min-w-[10px] lg:min-w-[22px] min-h-[10px] lg:min-h-[22px] "
                src={ListType}
                alt="list item"
              />
              <span>
                Kendine en uygun programı arayan tüm genç yetenekler MT&Staj
                Programları Zirvesi’ne katılabilir.
              </span>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
};
export default WhoCanApply;
